import { ExternalLink } from 'lucide-react';
import type { ProductWidgetData } from '@/types';

interface ProductWidgetProps {
  data: ProductWidgetData;
  preview?: boolean;
}

const ProductWidget = ({ data, preview = false }: ProductWidgetProps) => {
  const formatPrice = (price: number, currency: string) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency,
    }).format(price);
  };

  const handleClick = (e: React.MouseEvent) => {
    if (preview) {
      e.preventDefault();
    }
  };

  return (
    <a
      href={data.url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
      className="block bg-white dark:bg-dark-800 rounded-2xl shadow-soft dark:shadow-none overflow-hidden hover:shadow-card transition-all duration-200 group"
    >
      <div className="aspect-video bg-gray-100 dark:bg-dark-700 overflow-hidden">
        <img
          src={data.imageUrl}
          alt={data.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
        />
      </div>
      <div className="p-4">
        <div className="flex items-start justify-between gap-2 mb-2">
          <h3 className="font-medium text-dark-800 dark:text-white line-clamp-2">
            {data.title}
          </h3>
          <ExternalLink className="w-4 h-4 text-gray-400 flex-shrink-0 group-hover:text-lime-500 transition-colors" />
        </div>
        {data.description && (
          <p className="text-sm text-gray-500 dark:text-gray-400 mb-3 line-clamp-2">
            {data.description}
          </p>
        )}
        <p className="text-lg font-bold text-lime-600">
          {formatPrice(data.price, data.currency)}
        </p>
      </div>
    </a>
  );
};

export default ProductWidget;
